// extracted by mini-css-extract-plugin
module.exports = {"locations_warning":"BulkLocationChange_locations_warning__275RC","locations_button":"BulkLocationChange_locations_button__1h10p"};